<dv-tabs [tabLinks]="tabLinks()" />
<router-outlet />
